import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { AmHolidayTypeDuration } from '../../interfaces/am-api.interface';

@Component({
  selector: 'fin-am-duration-selector',
  templateUrl: './am-duration-selector.component.html',
  styleUrls: ['./am-duration-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AmDurationSelectorComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  readonly disabled = input(false);

  readonly selectedDuration = input<AmHolidayTypeDuration>();

  readonly durationOptions = input<AmHolidayTypeDuration[]>();

  readonly setDuration = output<AmHolidayTypeDuration>();

  modalOpen = false;

  openModal(): void {
    this.modalOpen = true;
  }

  onDurationSelect(duration: AmHolidayTypeDuration): void {
    this.setDuration.emit(duration);
    this.modalOpen = false;
  }
}
